import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.less';
import 'antd/dist/antd.less';
import Router from './router';
import { Provider } from 'react-redux';
import store from './store/store';
import reportWebVitals from './reportWebVitals';



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}><Router /></Provider>
);
// root.render(
//   <React.StrictMode>
//     <Router />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
